export default function AppCard({ app, lang }) {
  if (app.placeholder) {
    return (
      <div style={styles.placeholder}>
        <span style={styles.placeholderText}>
          {lang === 'ko' ? '더 만들고 있어요' : 'More coming'}
        </span>
      </div>
    );
  }

  const isFeatured = app.featured;

  return (
    <div style={{ ...styles.card, ...(app.coming ? styles.cardComing : {}) }}>

      {/* 왼쪽 — 이미지 or 검정 배경 */}
      <div style={{ ...styles.cardLeft, ...(app.coming ? styles.cardLeftComing : {}), ...(isFeatured ? styles.cardLeftFeatured : {}) }}>
        {isFeatured ? (
          <div style={styles.imgWrap}>
            {app.image
              ? <img src={app.image} alt={app.name} style={styles.img} />
              : (
                <div style={styles.imgPlaceholder}>
                  <div style={styles.imgPlaceholderIcon} />
                  <span style={styles.imgPlaceholderText}>
                    {lang === 'ko' ? '스크린샷\n이미지 자리' : 'Screenshot\nplaceholder'}
                  </span>
                </div>
              )
            }
          </div>
        ) : (
          <>
            <div style={{ ...styles.appName, ...(app.coming ? styles.appNameComing : {}) }}>
              {app.name}
            </div>
            <span style={{ ...styles.badge, ...(app.coming ? styles.badgeComing : styles.badgeLive) }}>
              {app.coming
                ? (lang === 'ko' ? '준비 중' : 'Coming soon')
                : (lang === 'ko' ? '라이브' : 'Live')}
            </span>
          </>
        )}
      </div>

      {/* 오른쪽 — 설명 */}
      <div style={{ ...styles.cardRight, ...(app.coming ? styles.cardRightComing : {}), ...(isFeatured ? styles.cardRightFeatured : {}) }}>
        {isFeatured && (
          <div>
            <span style={{ ...styles.badge, ...styles.badgeLive, color: 'var(--ink-soft)', marginBottom: '.6rem', display: 'block' }}>
              {lang === 'ko' ? '라이브' : 'Live'}
            </span>
            <div style={{ ...styles.appName, color: 'var(--ink)', fontStyle: 'italic', fontSize: '2.2rem' }}>
              {app.name}
            </div>
          </div>
        )}
        <p style={{ ...styles.desc, ...(app.coming ? styles.descComing : {}) }}>
          {app.desc[lang]}
        </p>
        {app.link && (
          <a href={app.link} target="_blank" rel="noopener noreferrer" style={styles.link}>
            {app.linkLabel || `${app.name.toLowerCase()} →`}
          </a>
        )}
      </div>
    </div>
  );
}

const styles = {
  card: {
    display: 'flex',
    flexDirection: 'row',
    border: '1px solid var(--ink-pale)',
    borderRadius: '2px',
    overflow: 'hidden',
    transition: 'border-color .25s, box-shadow .25s',
    cursor: 'default',
  },
  cardComing: {},
  cardLeft: {
    background: 'var(--ink)',
    padding: '2rem 1.8rem',
    width: '140px',
    flexShrink: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  cardLeftComing: { background: 'var(--ink-mid)' },
  cardLeftFeatured: {
    padding: 0,
    background: 'var(--paper-dim)',
    overflow: 'hidden',
    minHeight: '160px',
  },
  cardRight: {
    padding: '1.8rem 2rem',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    background: 'var(--paper)',
  },
  cardRightComing: { background: 'var(--paper-dim)' },
  cardRightFeatured: {
    padding: '2.4rem 2.6rem',
    justifyContent: 'flex-start',
    gap: '1.4rem',
  },
  appName: {
    fontFamily: 'var(--serif)',
    fontSize: '1.45rem',
    fontWeight: 200,
    fontStyle: 'italic',
    color: '#fff',
    letterSpacing: '-.02em',
    lineHeight: 1.1,
  },
  appNameComing: { opacity: .55 },
  badge: {
    fontFamily: 'var(--mono)',
    fontSize: '.5rem',
    letterSpacing: '.18em',
    textTransform: 'uppercase',
    marginTop: '1rem',
    display: 'block',
  },
  badgeLive:   { color: 'rgba(255,255,255,.5)' },
  badgeComing: { color: 'rgba(255,255,255,.28)' },
  desc: {
    fontSize: '.87rem',
    fontWeight: 300,
    lineHeight: 1.9,
    color: 'var(--ink-mid)',
  },
  descComing: { color: 'var(--ink-soft)' },
  link: {
    fontFamily: 'var(--mono)',
    fontSize: '.57rem',
    letterSpacing: '.1em',
    color: 'var(--ink-soft)',
    textDecoration: 'none',
    marginTop: '1.2rem',
    display: 'inline-block',
  },
  imgWrap: {
    width: '100%',
    aspectRatio: '1 / 1',
    maxHeight: '200px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'var(--paper-dim)',
  },
  img: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block',
  },
  imgPlaceholder: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '.7rem',
    width: '100%',
    minHeight: '160px',
  },
  imgPlaceholderIcon: {
    width: '36px',
    height: '36px',
    border: '1.5px dashed var(--ink-pale)',
    borderRadius: '4px',
  },
  imgPlaceholderText: {
    fontFamily: 'var(--mono)',
    fontSize: '.55rem',
    letterSpacing: '.14em',
    textTransform: 'uppercase',
    color: 'var(--ink-pale)',
    textAlign: 'center',
    whiteSpace: 'pre-line',
    lineHeight: 1.8,
  },
  placeholder: {
    border: '1px dashed var(--ink-pale)',
    borderRadius: '2px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '110px',
    opacity: .32,
    background: 'transparent',
  },
  placeholderText: {
    fontFamily: 'var(--mono)',
    fontSize: '.6rem',
    letterSpacing: '.16em',
    textTransform: 'uppercase',
    color: 'var(--ink-soft)',
  },
};
